import { Component, computed, inject, input, output } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { TranslocoPipe } from "@jsverse/transloco";
import { TranslocoDecimalPipe } from "@jsverse/transloco-locale";
import { TinyPlot } from "src/app/shared/contract/Address/tiny-plot";
import { FormatDatePipe } from "src/app/shared/pipes/format-date.pipe";
import { ConversionService } from "src/app/shared/services/conversion.service";
import { PlotLookupObjectViewModel } from "../models/plot-lookup-view-model";

@Component({
  selector: "app-tiny-plot-object-list",
  templateUrl: "./tiny-plot-object-list.component.html",
  styleUrl: "./tiny-plot-object-list.component.scss",
  imports: [MatIcon, MatTooltip, TranslocoPipe, FormatDatePipe, TranslocoDecimalPipe]
})
export class TinyPlotObjectListComponent {
  readonly conversionService = inject(ConversionService);

  readonly plotObjects = input<TinyPlot[]>([]);
  readonly objectSelected = output<TinyPlot>();

  protected plotList = computed(() => {
    const objects = this.plotObjects();

    if (!objects || objects.length === 0) {
      return [];
    }

    let viewModel: (PlotLookupObjectViewModel & { originalObject: TinyPlot })[] = [];

    objects.forEach(obj => {
      viewModel.push({
        Area: obj.Area,
        TinyPlotNumber: obj.TinyPlotNumber,
        originalObject: obj,
        isCache: obj.FromAccumateCache,
        creationDateTime: obj.CreationDateTime ? new Date(obj.CreationDateTime) : null
      });

      viewModel = viewModel.sort((a, b) => {
        if (a.isCache === b.isCache) return 0;
        return a.isCache ? -1 : 1;
      });
    });

    return viewModel.sort((a, b) => {
      if (a.isCache === b.isCache) return 0;
      return a.isCache ? -1 : 1;
    });
  });

  protected selectObject(obj: TinyPlot) {
    this.objectSelected.emit(obj);
  }
}
